import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AppoinmentserviceService {

  constructor(private http: HttpClient) { }

  get_doctors() {
    return this.http.get(`${environment.API_Base_URL}` + `Doctor/GetAllDoctor`)
  }

  get_complaint() {
    return this.http.get(`${environment.API_Base_URL}` + `ComplaintMst/GetComplaintMst_DD`)
  }

  get_diseases() {
    return this.http.get(`${environment.API_Base_URL}` + `Diseases/GetDiseases_DD`)
  }
  
  get_allergy() {
    return this.http.get(`${environment.API_Base_URL}` + `AllergySigns/GetAllergySigns_DD`)
  }

  get_symptoms() {
    return this.http.get(`${environment.API_Base_URL}` + `SymptomsMst/GetSymptomsMst_DD`)
  }
  get_symptomsbyid(id: any) {
    return this.http.get(`${environment.API_Base_URL}` + `SymptomsMst/GetSymptomsMstById?Id=${id}`)
  }


  Post_appoinment(data) {
    return this.http.post(`${environment.API_Base_URL}` + `Appointment/Self/InsertAppointment`, data)
  }

  get_Discipline() {
    return this.http.get(`${environment.API_Base_URL}` + `Discipline/GetDiscipline_DD`)
  } 

  get_doctordd(){
    return this.http.get(`${environment.API_Base_URL}` + `Doctor/Doctor_DD`)
  }
  get_doctorbyhospitalId(HospitalId) {
    return this.http.get(`${environment.API_Base_URL}` + `Doctor/Self/GetDoctorByHospitalId?HospitalId=${HospitalId}`)
  }

  get_appoinment(){
    return this.http.get(`${environment.API_Base_URL}` + `Appointment/Self/GetAppointmentById`)
  }
  Get_All_Medication(){
    return this.http.get(`${environment.API_Base_URL}` + `Medication/GetAllMedication`)
  }
  Update_appoinment(data){
      return this.http.put(`${environment.API_Base_URL}` + 'Appointment/Self/UpdateAppointment',data)
  }  

  get_appoinbyId(data){
    return this.http.get(`${environment.API_Base_URL}` + `Appointment/Self/GetAppointmentById?Appt_Id=${data}`)
  }

  Get_Allergy(){
    return this.http.get(`${environment.API_Base_URL}`+`AllergySigns/GetAllergySigns_DD`)
  }

  GetDoctorList_BasedonSchedule(select_date: any, select_FrmTime, select_toTime, Sp_Id,Hos_Id) {
    return this.http.get(`${environment.API_Base_URL}` + `Appointment/GetDoctorDD?Select_day=${select_date}&Select_FrmTime=${select_FrmTime}&Select_toTime=${select_toTime}&Sp_Id=${Sp_Id}&Hos_Id=${Hos_Id}`)
  }

  Get_HospitalDD() {
    return this.http.get(`${environment.API_Base_URL}` + `Hospital/Admin/GetHospital_DD`)
  }
  get_patientlogo(PR_Id) {
    return this.http.get(`${environment.API_Base_URL}` + `Hospital/GetPatApptHosp_Logo?PR_Id=${PR_Id}`)
  }
  Get_Userprofile(){
    return this.http.get(`${environment.API_Base_URL}`+`User/GetPatientProfile`)
  }
  Get_specialization() {
    return this.http.get(`${environment.API_Base_URL}` + `SpecilistDoctor/GetSpecilistDoctor_DD`)
  }

}
